import { FormattedMessage } from 'react-intl'

import { Message, MessageOwner, MessageTime } from '~/DesignSystem/components/messages'
import { Icon } from '~/DesignSystem/Icon'

type MessageProps = React.ComponentProps<typeof Message>

export type IncomingMessageProps = {
  owner?: string
  time?: number
} & Omit<MessageProps, 'direction' | 'variant'> & {
    direction?: MessageProps['direction']
    variant?: MessageProps['variant']
  }

function IncomingMessage({
  owner,
  time,
  children,
  direction = 'incoming',
  variant = 'secondary',
  ...props
}: IncomingMessageProps) {
  return (
    <Message direction={direction} variant={variant} {...props}>
      <MessageOwner picture={<Icon value="ai" />}>
        {owner || <FormattedMessage id="chat.agentMessage.displayName" />}
      </MessageOwner>
      {children}
      {!!time && <MessageTime>{time}</MessageTime>}
    </Message>
  )
}

export { IncomingMessage }
